export default __webpack_public_path__ + "static/media/YLFM.aa4d8ed9.svg";